import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth2 } from "@/api/auth";

import * as actionTypes from "./actionTypes";

export const updateCrisisRiskPatients = (data) => {
  return {
    payload: {
      lastEvaluatedKey: data.last_evaluated_key,
      practiceId: data.practiceId,
      reports: data.reports,
    },
    type: actionTypes.UPDATE_CRISIS_RISK_REPORT,
  };
};

export const fetchCrisisRiskPatients = ({ context, data, dispatch } = {}) => {
  return httpAuth2
    .post("/v1/admin/get_patients_with_crisis_risk", {
      context,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      json: data,
    })
    .json()
    .then((response) => {
      dispatch(
        updateCrisisRiskPatients({
          ...response,
          practiceId: data.practiceId,
        }),
      );

      return response;
    });
};
